var map = {
	"./Mypic.png": 3755,
	"./Redux.png": 3076,
	"./c++.png": 8361,
	"./c.png": 2539,
	"./mongo.png": 8118,
	"./myPic.png": 1619,
	"./node.png": 445,
	"./python.png": 7647,
	"./react.png": 3532,
	"./sql.png": 7740,
	"./tensorFlow.png": 8952
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6713;